import {
  Container,
  Grid,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { BoolStatus } from 'features/plc/components/common';
import PLCButton from 'features/plc/components/PLCButton';
import {
  getPathName,
  PLC_PATHS,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValues } from 'features/plc/providers/PLCProvider';
import React from 'react';

const SYSTEM_INFO_FIELDS = [
  { label: 'Air Feedback', path: PLC_PATHS.status.pressInputs.airFeedback, kind: 'bool' },
  { label: 'Chiller Feedback', path: PLC_PATHS.status.pressInputs.chillerFeedback, kind: 'bool' },
  { label: 'Heater Switch', path: PLC_PATHS.status.pressInputs.heaterEmergencySwitch, kind: 'bool' },
];

export default function SystemStatusAndControl() {
  const values = usePLCValues([
    ...SYSTEM_INFO_FIELDS.map((field) => field.path),
    PLC_PATHS.status.canForceInstronForward,
    PLC_PATHS.status.canForcePLCForward,
  ]);
  const canForceInstronForward = values[
    getPathName(PLC_PATHS.status.canForceInstronForward)
  ] ?? false;
  const canForcePLCForward = values[
    getPathName(PLC_PATHS.status.canForcePLCForward)
  ] ?? false;

  return (
    <Container header={<Header variant="h2">System Status and Control</Header>}>
      <SpaceBetween size="m">
        <Grid
          gridDefinition={[
            { colspan: 6 }, { colspan: 6 },
            { colspan: 6 }, { colspan: 6 },
            { colspan: 6 }, { colspan: 6 },
          ]}
        >
          {SYSTEM_INFO_FIELDS.map((field) => {
            const value = values[getPathName(field.path)];

            return (
              <BoolStatus
                key={getPathName(field.path)}
                label={field.label}
                value={value}
              />
            );
          })}
        </Grid>
        <Grid
          gridDefinition={[
            { colspan: 12 },
            { colspan: 12 },
          ]}
        >
          <PLCButton
            path={PLC_PATHS.cmd.instronDi1ManualPulse}
            value
            fullWidth
            disabled={!canForceInstronForward}
          >
            Force Instron Forward
          </PLCButton>
          <PLCButton
            path={PLC_PATHS.cmd.simulateInstronDo1Pulse}
            value
            fullWidth
            disabled={!canForcePLCForward}
          >
            Force PLC Forward
          </PLCButton>
        </Grid>
      </SpaceBetween>
    </Container>
  );
}
